import React from "react";
import { SEO } from "@bluefin/components";
import { Grid, Segment, Embed } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import "../style/book-now.css";

export default class BookNowPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          ogUrl={"https://www.prestigebeautywellness.com/book-now/"}
        />
        <Grid
          className={"custom-page-book-now custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"qbojnqgxtkxewkwo"}
            style={{ padding: 16 }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"ktfmfqrnuffahnhk"}
              style={{ padding: 16 }}
              width={14}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__2bfbb2c0-e751-449d-adc9-cca758a5aaa0"}
                >
                  <Embed
                    url={
                      "https://na1.meevo.com/CustomerPortal/onlinebooking/booking/location?tenantId=200239"
                    }
                    active={true}
                    defaultActive={true}
                    className={"booking-widget"}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 30352 }) {
      title
      seoTitle
      description
    }
  }
`;
